<template>
  <div class="property-create">
    <h1 class="center-text">Create Property</h1>
    <form @submit.prevent="createProperty">
      <div v-if="apiError" class="error center-element">
        Error: {{ apiErrorMessage }}<br />
      </div>
      <div class="form-300 center-element">
        <label>Property Name</label><br />
        <input
          v-model.trim="property.name"
          type="text"
          placeholder="Property Name"
          onfocus="this.placeholder = ''"
          onblur="this.placeholder = 'Property Name'"
          required
        /><br />
        <label>Property URL</label><br />
        <input
          v-model.trim="property.url"
          type="text"
          placeholder="Property URL"
          onfocus="this.placeholder = ''"
          onblur="this.placeholder = 'Property URL'"
        /><br />
        <button type="submit" class="button button-300">Create Property</button>
      </div>
    </form>
  </div>
</template>

<script>
import api from "@/api/index";
const apiServiceProperty = new api.APIServiceProperty();

export default {
  data() {
    return {
      property: {
        name: "",
        url: "",
        email: ""
      },
      apiError: false,
      apiErrorMessage: ""
    };
  },
  methods: {
    createProperty: function() {
      this.apiError = false;
      this.apiErrorMessage = "";
      apiServiceProperty
        .createProperty(this.property)
        .then(data => {
          this.$router.push("/console/main");
        })
        .catch(error => {
          this.apiError = true;
          this.apiErrorMessage = error;
        });
    }
  }
};
</script>
